import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { DOCUMENT, isPlatformBrowser } from '@angular/common';

@Injectable({
  providedIn: 'any',
})
export class ElementVisibilityService {
  isElVisible = true;
  private window: Window;

  constructor(
    @Inject(DOCUMENT) private document: Document,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {
    this.window = this.document.defaultView;
  }

  checkElementVisiblity(element): void {
    if (!element) {
      return;
    }

    // Skip visibility check during SSR
    if (!isPlatformBrowser(this.platformId)) {
      this.isElVisible = true;
      return;
    }

    // Check if getBoundingClientRect method exists
    if (typeof element.getBoundingClientRect !== 'function') {
      this.isElVisible = true;
      return;
    }

    const position = element.getBoundingClientRect();
    if (position.top >= window.innerHeight) {
      this.isElVisible = true;
      return;
    }
    if (position.top < window.innerHeight && position.bottom >= 0) {
      this.isElVisible = true;
      return;
    }
    this.isElVisible = false;
  }
}
